import React, { useContext, useEffect, useRef, useState } from "react";
import Layout from "./layout/Layout";
import { AppStateContext } from "../state/AppProvider";
import { ChatHistoryPanel } from "../components/ChatHistory/ChatHistoryPanel";
import { useNavigate } from "react-router-dom";
import { Modal } from "@fluentui/react";
import { IconButton } from "@fluentui/react/lib/Button";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import styles from "./MyProfile.Module.css";
import Select from "react-select";
import { BackendURL } from "../../env";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
// const industryCategory = [
//   { value: 'general', label: 'General' },
//   { value: 'automobile', label: 'Automobile' },
//   { value: 'pharma', label: 'Pharma' },
//   { value: 'finance', label: 'Financial' },
//   { value: 'manufacturing', label: 'Manufacturing' },
//   { value: 'it', label: 'IT' },
// ]

import {
  CosmosDBStatus,
  fetchDailyBillingDetail,
  fetchMonthlyBillingDetail,
} from "../api";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const useStyles = mergeStyleSets({
  modalContainer: {
    padding: 20,
    backgroundColor: "white",
    minWidth: 992,
    minHeight: 300,
  },

  closeIcon: {
    position: "absolute",
    top: 10,
    right: 10,
    zIndex: 1,
  },
});

interface MyProfileModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  initialSection?: "usage" | "modelDetails";
  initialModelTab?: "subscribed" | "available";
}

export const exportToExcel = (data: any[], fileName: string) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(dataBlob, `${fileName}.xlsx`);
};

type Model = {
  ID: number;
  Name: string;
  Display_Name: string;
  Description?: string | null;
  Input_Cost?: number | string | null;
  Output_Cost?: number | string | null;
  Model_Provider?: string | null;
  Is_Enabled: number;
  isChecked?: boolean;
  Model_Selection_Type: string | null;
  Token_Limit_Per_Day: string | number | null;
  Model_id?: string | null;
  Display_Seq?: number | null;
  IsDocumentValid?: boolean | null;
  Category?: string | null;
  Initial_Heading?: string | null;
  ChannelType?: string | null;
  tenant_id?: string | number | null;
  is_Voice_Enabled?: number | boolean | null;
  Is_Admin?: boolean | null;
  Expertise?: string | null;
};

type OptionType = {
  value: string;
  label: string;
};

const MyProfile: React.FC<MyProfileModalProps> = ({
  isOpen,
  onDismiss,
  initialSection = "usage",
  initialModelTab = "subscribed",
}) => {
  const [profileTab, setProfileTab] = useState<"usage" | "modelDetails">(
    initialSection,
  );
  const [usageTab, setUsageTab] = useState<"last30days" | "last12months">(
    "last30days",
  );
  const [modelTab, setModelTab] = useState<"subscribed" | "available">(
    initialModelTab,
  );
  const [monthlyBillingData, setMonthlyBillingData] = useState([]);
  const [dailyBillingData, setDailyBillingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState<Model[]>([]);
  const [loadingModelId, setLoadingModelId] = useState<string | null>(null);
  const [availableModels, setAvailableModels] = useState<Model[]>([]);
  const [subscribedModelIds, setSubscribedModelIds] = React.useState<
    Set<string>
  >(new Set());
  const [confirmingId, setConfirmingId] = React.useState(null);
  const [industryCategory, setIndustryCategory] = useState<OptionType[]>([]);
  const [selectedOption, setSelectedOption] = useState<OptionType | null>(null);
  const [initialOption, setInitialOption] = useState<OptionType | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  const appStateContext = useContext(AppStateContext);
  const styles = useStyles;
  const modalContentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (
        modalContentRef.current &&
        !modalContentRef.current.contains(event.target)
      ) {
        onDismiss();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onDismiss]);

  useEffect(() => {
    const loadModels = async () => {
      try {
        const modelData = (await appStateContext?.state.modelDetails) || [];
        setModels(modelData);
      } catch (error) {
        console.error("Error loading model details:", error);
      }
    };

    loadModels();
  }, []);

  // useEffect(() => {
  //   const fetchModelDetails = async () => {
  //     const userName = localStorage.getItem("userId") || "";
  //     const domain = localStorage.getItem("domain") || "";
  //     try {
  //       const response = await fetch("/get_model_details", {
  //         method: "post",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ UserName: userName, Domain: domain }),
  //       });
  //       if (!response.ok)
  //         throw new Error("Failed to get model detils for my profile page");
  //       const data = await response.json();
  //       setModels(data);
  //     } catch (error) {
  //       console.error("Error fetching model details:", error);
  //     }
  //   };
  //   fetchModelDetails();
  // }, []);

  const fetchDropdownOptions = async () => {
    try {
      const response = await fetch(`${BackendURL}/Category_Dropdown_list`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch icons.");
      }
      const data = await response.json();

      return data;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    const getData = async () => {
      const optionsData = await fetchDropdownOptions();

      const formattedOptions = optionsData.map((item: any) => ({
        value: item.Expertise,
        label: item.Expertise,
      }));

      setIndustryCategory(formattedOptions);
    };

    getData();
  }, []);

  const SaveDropdownOptions = async (selectedOption: { value: any } | null) => {
    try {
      if (!selectedOption || !selectedOption.value) {
        throw new Error("No expertise selected.");
      }

      setIsSaving(true);

      const Email = localStorage.getItem("Email");

      const response = await fetch(`${BackendURL}/Save_User_Expertise`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Email: Email,
          Expertise: selectedOption.value,
        }),
      });

      if (!response.ok) {
        const errorDetails = await response.text();
        throw new Error(
          `Request failed. Status: ${response.status}, Details: ${errorDetails}`,
        );
      }

      localStorage.setItem("Expertise", selectedOption.value);
      setInitialOption(selectedOption.value);

      window.dispatchEvent(new Event("expertiseUpdated"));

      toast.success("Expertise has been saved");
      setIsSaving(false);

      return await response.json();
    } catch (error) {
      toast.error("Failed to save expertise");
      setIsSaving(false);
    }
  };

  // const SaveDropdownOptions = async (selectedOption: { value: any; } | null) => {
  //   try {
  //     if (!selectedOption || !selectedOption.value) {
  //       throw new Error('No expertise selected.');
  //     }
  //     setIsSaving(true);

  //     const Email = localStorage.getItem('Email');

  //     const response = await fetch(`${BackendURL}/Save_User_Expertise`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //       Email: Email,
  //       Expertise: selectedOption.value,
  //       }),
  //     });

  //     if (!response.ok) {
  //       const errorDetails = await response.text();
  //       throw new Error(`Request failed. Status: ${response.status}, Details: ${errorDetails}`);
  //     }
  //      toast.success(`Expertise has been saved`);
  //     const data = await response.json();
  // //    console.log('Saved Data:', data);
  //     return data;
  //   } catch (error) {
  //   toast.error(`Failed to save expertise`);
  //   setIsSaving(false);

  //   }
  // };

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/");
  };

  useEffect(() => {
    if (isOpen) {
      setProfileTab(initialSection);
      setModelTab(
        initialSection === "modelDetails" ? initialModelTab : "subscribed",
      );
    }
  }, [initialModelTab, initialSection, isOpen]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [monthlyData, dailyData] = await Promise.all([
          fetchMonthlyBillingDetail(),
          fetchDailyBillingDetail(),
        ]);
        setMonthlyBillingData(monthlyData);
        setDailyBillingData(dailyData);
      } catch (error) {
        console.error("Error fetching billing details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getMonthlyTotal = () => {
    const totals: Record<string, { tokens: number; cost: number }> = {};
    let totalCost = 0;

    monthlyBillingData.forEach((item: any) => {
      for (const key in item) {
        if (
          key !== "Total_Cost" &&
          key !== "Month" &&
          key !== "MonthNm" &&
          key !== "Year"
        ) {
          if (typeof item[key] === "string") {
            const [tokenStr, costStr] = item[key]
              .split(",")
              .map((val: string) => val.trim());
            const tokens = parseInt(tokenStr.replace(/,/g, ""));
            const cost = parseFloat(costStr);
            if (!isNaN(tokens) && !isNaN(cost)) {
              totals[key] = {
                tokens: (totals[key]?.tokens || 0) + tokens,
                cost: (totals[key]?.cost || 0) + cost,
              };
            }
          }
        }
      }
      totalCost += item.Total_Cost || 0;
    });

    return { totals, totalCost: totalCost.toFixed(2) };
  };

  const SvgSpinner = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      stroke="red"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );

  const getDailyTotal = () => {
    const totals: Record<string, { tokens: number; cost: number }> = {};
    let totalCost = 0;

    dailyBillingData.forEach((item: any) => {
      for (const key in item) {
        if (key !== "Total_Cost" && key !== "Date") {
          if (typeof item[key] === "string") {
            const [tokenStr, costStr] = item[key]
              .split(",")
              .map((val: string) => val.trim());
            const tokens = parseInt(tokenStr.replace(/,/g, ""));
            const cost = parseFloat(costStr);
            if (!isNaN(tokens) && !isNaN(cost)) {
              totals[key] = {
                tokens: (totals[key]?.tokens || 0) + tokens,
                cost: (totals[key]?.cost || 0) + cost,
              };
            }
          }
        }
      }
      totalCost += item.Total_Cost || 0;
    });

    return { totals, totalCost: totalCost.toFixed(2) };
  };

  const monthlyTotal = getMonthlyTotal();
  const dailyTotal = getDailyTotal();

  const sideBarEnable = appStateContext?.state.isChatHistoryOpen;

  const handleDownloadReport = async () => {
    setLoading(true);
    let dataToExport = [];

    try {
      if (usageTab === "last30days") {
        dataToExport = await fetchDailyBillingDetail();
      } else if (usageTab === "last12months") {
        dataToExport = await fetchMonthlyBillingDetail();
      }
      exportToExcel(
        dataToExport,
        usageTab === "last30days"
          ? "DailyBillingReport"
          : "MonthlyBillingReport",
      );
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubscribeLatest = async (
    modelId: string,
    Display_Name: string,
  ) => {
    setLoadingModelId(modelId);

    if (!modelId) {
      toast.warn("Please select a model to subscribe.");
      setLoadingModelId(null);
      return;
    }

    try {
      const Email = localStorage.getItem("Email");

      // if (!Email) {
      //   throw new Error("Email is not defined");
      // }

      const response = await fetch(`${BackendURL}/Send_Email_Subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Email,
          modelId,
          Display_Name,
          title: "Subscription Request",
          description: "Please approve subscription for the selected model.",
        }),
      });

      if (!response.ok) {
        let errorMessage = "Failed to send subscription data.";
        try {
          const errorData = await response.json();
          errorMessage = errorData?.message || errorMessage;
        } catch {}
        throw new Error(errorMessage);
      }

      toast.success(
        `Subscription request for model "${Display_Name}" has been sent to the approver.`,
      );
      setSubscribedModelIds((prev) => new Set(prev).add(modelId));
    } catch (error: unknown) {
      console.error("Subscription failed:", error);

      let message = "Failed to subscribe. Please try again later.";
      if (error instanceof Error) {
        message = error.message;
      }

      toast.error(message);
    } finally {
      setLoadingModelId(null);
    }
  };

  useEffect(() => {
    const loadExpertiseFromModel = async () => {
      try {
        const models = appStateContext?.state.modelDetails || [];

        const modelWithExpertise = models.find(
          (model: { Expertise: string }) =>
            model.Expertise && model.Expertise.trim() !== "",
        );

        if (modelWithExpertise) {
          const matchedOption = industryCategory.find(
            (opt) => opt.value === modelWithExpertise.Expertise,
          );
          if (matchedOption) {
            setSelectedOption(matchedOption);
            setInitialOption(matchedOption);
          }
        } else {
          setSelectedOption(null);
          setInitialOption(null);
        }
      } catch (error) {
        console.error("Failed to load expertise:", error);
        setSelectedOption(null);
      }
    };

    loadExpertiseFromModel();
  }, [industryCategory]);

  const isDisabled =
    !selectedOption?.value ||
    initialOption?.value === selectedOption?.value ||
    isSaving;

  const formatModelValue = (value: unknown, fallback = "-") => {
    if (value === null || value === undefined || value === "") return fallback;
    if (typeof value === "boolean") return value ? "Yes" : "No";
    return String(value);
  };

  const formatCost = (value: unknown) => {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    return Number.isNaN(numericValue)
      ? String(value)
      : numericValue.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 6,
        });
  };

  const formatTokenLimit = (value: unknown) => {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    return Number.isNaN(numericValue)
      ? `${String(value)} tokens/day`
      : `${numericValue.toLocaleString()} tokens/day`;
  };

  const formatEnabledFlag = (value: unknown) => {
    if (value === true || value === 1 || value === "1") return "Yes";
    if (value === false || value === 0 || value === "0") return "No";
    return formatModelValue(value);
  };

  const renderModelDetails = (model: Model) => {
    const details = [
      ["Provider", model.Model_Provider],
      ["Input Cost", formatCost(model.Input_Cost)],
      ["Output Cost", formatCost(model.Output_Cost)],
      [
        "Token Limit",
        formatTokenLimit(model.Token_Limit_Per_Day),
      ],
    ];

    return (
      <div className="tokens-wrapper">
        {details.map(([label, value]) => (
          <span key={label}>
            <i>
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path></svg>
            </i>
            {label}: <strong>{formatModelValue(value)}</strong>
          </span>
        ))}
      </div>
    );
  };

  const renderModelInfoIcon = (
    tooltipId: string,
    description?: string | null,
  ) => (
    <i
      className="infoIcon"
      data-tooltip-id={tooltipId}
      data-tooltip-content={description?.trim() || "No description available"}
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 256 256"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z"></path>
      </svg>
      <ReactTooltip id={tooltipId} place="top" className="customTooltip" />
    </i>
  );

  // const isDisabled: boolean =
  //   !selectedOption ||
  //   (initialOption !== null && selectedOption.value === initialOption.value) ||
  //   isSaving;

  const handleUnSubscribeLatest = async (
    modelId: string,
    Display_Name: string,
  ) => {
    setLoadingModelId(modelId);

    if (!modelId) {
      toast.warn("Please select a model to unsubscribe.");
      setLoadingModelId(null);
      return;
    }

    try {
      const Email = localStorage.getItem("Email");
      // if (!Email) throw new Error("Email is not presnet in local storage");

      const response = await fetch(`${BackendURL}/Send_Email_UnSubscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Email, modelId, Display_Name }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || "Something went wrong");
      }

      setModels((prevModels) =>
        prevModels.map((model) =>
          String(model.ID) === modelId ? { ...model, Is_Enabled: 0 } : model,
        ),
      );

      toast.success(`${Display_Name} successfully unsubscribed.`);
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : "Failed to unsubscribe.";
      toast.error(message);
    } finally {
      setLoadingModelId(null);
    }
  };

  const confirmUnsubscribe = (model: Model) => {
    toast.info(
      <div>
        Are you sure you want to unsubscribe?
        <button
          onClick={() => {
            handleUnSubscribeLatest(String(model.ID), model.Display_Name);
            toast.dismiss();
          }}
          style={{
            backgroundColor: "#ff4d4f",
            color: "#fff",
            border: "none",
            padding: "3px 16px",
            borderRadius: "9px",
            cursor: "pointer",
            fontWeight: "600",
            transition: "background-color 0.3s ease",
            marginLeft: "32px",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#d9363e")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#ff4d4f")
          }
        >
          Yes
        </button>
      </div>,
      { autoClose: false },
    );
  };

  const subscribedModels = models.filter((m) => m.Is_Enabled === 1);
  const AvilableModel = models.filter((m) => m.Is_Enabled === 0);

  return (
    <>
      <Modal
        className="MyProfile_modalContainer"
        isBlocking={true}
        isOpen={isOpen}
        onDismiss={onDismiss}
      >
        <ToastContainer />
        <div className="modalContainer" ref={modalContentRef}>
          <div className="modal-header">
            <h1>My Profile</h1>
            <button onClick={onDismiss} className="chat_closeBtn">
              <i>
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.63603 5.63604C6.02656 5.24552 6.65972 5.24552 7.05025 5.63604L12 10.5858L16.9497 5.63604C17.3403 5.24552 17.9734 5.24552 18.364 5.63604C18.7545 6.02657 18.7545 6.65973 18.364 7.05025L13.4142 12L18.364 16.9497C18.7545 17.3403 18.7545 17.9734 18.364 18.364C17.9734 18.7545 17.3403 18.7545 16.9497 18.364L12 13.4142L7.05025 18.364C6.65972 18.7545 6.02656 18.7545 5.63603 18.364C5.24551 17.9734 5.24551 17.3403 5.63603 16.9497L10.5858 12L5.63603 7.05025C5.24551 6.65973 5.24551 6.02657 5.63603 5.63604Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </i>
            </button>
          </div>
          <div className="profilewrapper-main">
            <div className="myProfile-root-container">
              {/* {appStateContext?.state.isChatHistoryOpen &&
            appStateContext?.state.isCosmosDBAvailable?.status !==
            CosmosDBStatus.NotConfigured && } */}
              {/* <ChatHistoryPanel /> */}

              <div
                className={`myProfileContainer ${
                  sideBarEnable ? "myProfileContainer_active" : ""
                }`}
                style={{ paddingLeft: "0" }}
              >
                {/* <Layout onNewChat={newChat}/> */}
                {/* <div className="backBtnWrapper">
             <button className="backButton" onClick={handleBackClick}>
                <i>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    height="24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M216.4 163.7c5.1 5 5.1 13.3.1 18.4L155.8 243h231.3c7.1 0 12.9 5.8 12.9 13s-5.8 13-12.9 13H155.8l60.8 60.9c5 5.1 4.9 13.3-.1 18.4-5.1 5-13.2 5-18.3-.1l-82.4-83c-1.1-1.2-2-2.5-2.7-4.1-.7-1.6-1-3.3-1-5 0-3.4 1.3-6.6 3.7-9.1l82.4-83c4.9-5.2 13.1-5.3 18.2-.3z"></path>
                  </svg>
                </i>
                Back
              </button>
             </div> */}

                <div className="myProfile_overflowContainer">
                  <div className="myProfileInnerContainer">
                    <div className="myProfileTitle">
                      <div className="userDetails">
                        <h1>{localStorage.getItem("name")}</h1>
                        {/* <h5>Designation</h5> */}
                        <h6>{localStorage.getItem("Email")}</h6>
                      </div>
                      <div className="userDomain">
                        <p className="domain-label">Expertise Area</p>
                        <div className="expertise-wrapper">
                          <Select
                            options={industryCategory}
                            placeholder="Select Expertise"
                            className="custom-select"
                            classNamePrefix="custom"
                            value={selectedOption}
                            onChange={setSelectedOption}
                          />

                          <button
                            className="expertiseSave-btn"
                            disabled={isDisabled}
                            onClick={() => SaveDropdownOptions(selectedOption)}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="myUsageSection">
                      <p className="subtext">
                        Discover and create custom version of Lipi that combine
                        instructions and extra knowledge.
                      </p>
                    </div>

                    {/*  */}

                    <Box className="myProfielPriamyTab-wrapper">
                      <Tabs
                        value={profileTab}
                        onChange={(_, newValue) => setProfileTab(newValue)}
                        variant="fullWidth"
                        textColor="inherit"
                        TabIndicatorProps={{
                          style: { backgroundColor: "#c1272d" },
                        }}
                        sx={{
                          "& .MuiTab-root": {
                            fontWeight: 700,
                            textTransform: "none",
                          },
                          "& .Mui-selected": {
                            color: "#c1272d !important",
                          },
                        }}
                      >
                        <Tab label="My Usage" value="usage" />
                        <Tab label="Model Details" value="modelDetails" />
                      </Tabs>
                    </Box>

                    {profileTab === "usage" && (
                      <div className="myUsageSection">
                        {/* <h2>My Usage</h2> */}
                        <div className="myUsageReportWrapper">
                          <div className="myUsageReportWrapper-header">
                            <Box className="myprofileIntenalTabWrapper">
                              <Tabs
                                value={usageTab}
                                onChange={(_, newValue) =>
                                  setUsageTab(newValue)
                                }
                                textColor="inherit"
                                TabIndicatorProps={{
                                  style: { backgroundColor: "#c1272d" },
                                }}
                                sx={{
                                  minHeight: 44,
                                  "& .MuiTab-root": {
                                    minHeight: 44,
                                    color: "#5f6b7a",
                                    fontWeight: 700,
                                    textTransform: "none",
                                  },
                                  "& .Mui-selected": {
                                    color: "var(--mui-selected) !important",
                                  },
                                }}
                              >
                                <Tab label="Last 30 Days" value="last30days" />
                                <Tab
                                  label="Last 12 Months"
                                  value="last12months"
                                />
                              </Tabs>
                            </Box>
                          </div>

                          {usageTab === "last30days" && (
                            <div id="activeTabactiveTab">
                              <div className="myUsageReportWrapper-body">
                                <div className="models-section">
                                  {Object.entries(dailyTotal.totals).map(
                                    ([model, { tokens, cost }]) => {
                                      if (model === "totalCost") return null;
                                      return (
                                        <div
                                          className="reporsection "
                                          key={model}
                                        >
                                          <div className="modelTokencostWrapper">
                                            {" "}
                                            <div className="count">
                                              {tokens}

                                              <span className="count-subtext">
                                                {model === "LipiDALLE"
                                                  ? "Images"
                                                  : "Tokens"}
                                              </span>
                                            </div>
                                            <hr
                                              style={{
                                                height: "100%",
                                                background: "#767676",
                                                width: " 1px",
                                              }}
                                            ></hr>
                                            <div className="count-amount">
                                              {cost.toFixed(2)}

                                              <span className="count-subtext">
                                                <svg
                                                  stroke="currentColor"
                                                  fill="currentColor"
                                                  stroke-width="0"
                                                  viewBox="0 0 24 24"
                                                  height="32"
                                                  width="32"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    fill="none"
                                                    d="M0 0h24v24H0z"
                                                  ></path>
                                                  <path d="M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"></path>
                                                </svg>
                                              </span>
                                            </div>
                                          </div>
                                          <div className={`countText ${model}`}>
                                            {model}
                                          </div>
                                        </div>
                                      );
                                    },
                                  )}
                                </div>

                                <div className="total-section">
                                  <div className="total-reportsection total">
                                    <div className="count total">
                                      <i>
                                        <svg
                                          stroke="currentColor"
                                          fill="currentColor"
                                          stroke-width="0"
                                          viewBox="0 0 24 24"
                                          height="32"
                                          width="32"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill="none"
                                            d="M0 0h24v24H0z"
                                          ></path>
                                          <path d="M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"></path>
                                        </svg>
                                      </i>{" "}
                                      {dailyTotal.totalCost}
                                    </div>
                                    <div className="countText total">
                                      Total Cost (In Rupees)
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="myUsageReportWrapper-footer">
                                <button
                                  className="downloadReport"
                                  onClick={handleDownloadReport}
                                  disabled={loading}
                                >
                                  Download Report
                                  {loading ? (
                                    <span
                                      className="chatLoader"
                                      style={{ width: "16px", height: "16px" }}
                                    ></span>
                                  ) : (
                                    <i>
                                      <svg
                                        stroke="currentColor"
                                        fill="none"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        height="16"
                                        width="16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                        ></path>
                                      </svg>
                                    </i>
                                  )}
                                </button>
                              </div>
                            </div>
                          )}
                          {usageTab === "last12months" && (
                            <div id="last12months">
                              <div className="myUsageReportWrapper-body">
                                <div className="models-section">
                                  {Object.entries(monthlyTotal.totals).map(
                                    ([model, { tokens, cost }]) => {
                                      if (model === "totalCost") return null;
                                      return (
                                        <div
                                          className="reporsection last12MBg"
                                          key={model}
                                        >
                                          {/* <div className="count">
                                          {tokens}{" "}
                                          <span className="count-subtext">
                                            Tokens
                                          </span>
                                        </div> */}

                                          <div className="modelTokencostWrapper">
                                            <div className="count">
                                              {tokens}
                                              <span className="count-subtext">
                                                {model === "LipiDALLE"
                                                  ? "Images"
                                                  : "Tokens"}
                                              </span>
                                            </div>
                                            <hr
                                              style={{
                                                height: "100%",
                                                background: "#767676",
                                                width: " 1px",
                                              }}
                                            ></hr>
                                            <div className="count-amount">
                                              {cost.toFixed(2)}

                                              <span className="count-subtext">
                                                <svg
                                                  stroke="currentColor"
                                                  fill="currentColor"
                                                  stroke-width="0"
                                                  viewBox="0 0 24 24"
                                                  height="32"
                                                  width="32"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    fill="none"
                                                    d="M0 0h24v24H0z"
                                                  ></path>
                                                  <path d="M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"></path>
                                                </svg>
                                              </span>
                                            </div>
                                          </div>

                                          <div className={`countText ${model}`}>
                                            {model}
                                          </div>
                                        </div>
                                      );
                                    },
                                  )}
                                </div>

                                <div className="total-section">
                                  <div className="total-reportsection last12MBg total">
                                    <div className="count total">
                                      <i>
                                        <svg
                                          stroke="currentColor"
                                          fill="currentColor"
                                          stroke-width="0"
                                          viewBox="0 0 24 24"
                                          height="32"
                                          width="32"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill="none"
                                            d="M0 0h24v24H0z"
                                          ></path>
                                          <path d="M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"></path>
                                        </svg>
                                      </i>{" "}
                                      {monthlyTotal.totalCost}
                                    </div>
                                    <div className="countText total">
                                      Total Cost (In Rupees)
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="myUsageReportWrapper-footer">
                                <button
                                  className="downloadReport"
                                  onClick={handleDownloadReport}
                                  disabled={loading}
                                >
                                  Download Report
                                  {loading ? (
                                    <span
                                      className="chatLoader"
                                      style={{ width: "16px", height: "16px" }}
                                    ></span>
                                  ) : (
                                    <i>
                                      <svg
                                        stroke="currentColor"
                                        fill="none"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        height="16"
                                        width="16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                        ></path>
                                      </svg>
                                    </i>
                                  )}
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {profileTab === "modelDetails" && (
                      <div className="myModuleSection">
                        {/* <div className="myModuleSectionHeader">
                          <h2>Model Details</h2>
                        </div> */}

                        <div
                          className="myModuleWrapper"
                          style={{ display: "block" }}
                        >
                          <Box className="myprofileIntenalTabWrapper">
                            <Tabs
                              value={modelTab}
                              onChange={(_, newValue) => setModelTab(newValue)}
                              textColor="inherit"
                              TabIndicatorProps={{
                                style: { backgroundColor: "#c1272d" },
                              }}
                              sx={{
                                "& .MuiTab-root": {
                                  color: "#5f6b7a",
                                  fontWeight: 700,
                                  textTransform: "none",
                                },
                                "& .Mui-selected": {
                                  color: "var(--mui-selected) !important",
                                },
                              }}
                            >
                              <Tab
                                label={`Subscribed Models (${subscribedModels.length})`}
                                value="subscribed"
                              />
                              <Tab
                                label={`Available Models (${AvilableModel.length})`}
                                value="available"
                              />
                            </Tabs>
                          </Box>

                          {modelTab === "subscribed" && (
                            <div className="header-row">
                              {/* <div className="myModuleWrapper-header">
                                <h3>Subscribed Models</h3>
                              </div> */}

                              <div className="model-row">
                                {subscribedModels.map((model) => (
                                  <div
                                    className="model-row-wrapper"
                                    key={model.ID}
                                  >
                                    <div className="myModule">
                                      <i className="subscribed-icon">
                                        <svg
                                          stroke="currentColor"
                                          fill="currentColor"
                                          stroke-width="0"
                                          viewBox="0 0 24 24"
                                          height="100%"
                                          width="100%"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill="none"
                                            d="M0 0h24v24H0V0z"
                                          ></path>
                                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"></path>
                                        </svg>
                                      </i>
                                      <div className="moduleTokenDetailContainer">
                                        <span className="moduleLable">
                                          {model.Display_Name}
                                          {renderModelInfoIcon(
                                            `modelInfo-subscribed-${model.ID}`,
                                            model.Description,
                                          )}
                                        </span>
                                        {renderModelDetails(model)}
                                      </div>
                                    </div>
                                    {model.Model_Selection_Type == "default" ? (
                                      <div className="unsubscribed-btn-wrapper">
                                      <button
                                        className="unsubscribed-btn"
                                        style={{ width: "98px" }}
                                        disabled
                                      >
                                        Default
                                      </button>
                                      </div>
                                    ) : (
                                      <div className="unsubscribed-btn-wrapper">
                                        <button
                                          className="unsubscribed-btn"
                                          onClick={() =>
                                            confirmUnsubscribe(model)
                                          }
                                          disabled={
                                            loadingModelId === String(model.ID)
                                          }
                                        >
                                          {loadingModelId ===
                                            String(model.ID) && (
                                            <span
                                              style={{ marginRight: "8px" }}
                                            >
                                              <SvgSpinner />
                                            </span>
                                          )}
                                          Unsubscribe
                                        </button>
                                        <div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {modelTab === "available" &&
                            AvilableModel.length > 0 && (
                              <div className="header-row">
                                {/* <div className="myModuleWrapper-header">
                                <h3>Available Models</h3>
                              </div> */}

                                <div className="model-row">
                                  {AvilableModel.map((model) => (
                                    <div
                                      className="model-row-wrapper"
                                      key={model.ID}
                                    >
                                      <div className="myModule">
                                        <div className="moduleTokenDetailContainer">
                                          <span className="moduleLable">
                                            {model.Display_Name}
                                            {renderModelInfoIcon(
                                              `modelInfo-available-${model.ID}`,
                                              model.Description,
                                            )}
                                          </span>
                                          {renderModelDetails(model)}
                                        </div>
                                      </div>
                                      <div className="subscribed-btn-wrapper">
                                      <button
                                        className="subscribed-btn"
                                        style={{ width: "94px" }}
                                        onClick={() =>
                                          handleSubscribeLatest(
                                            String(model.ID),
                                            model.Display_Name,
                                          )
                                        }
                                        disabled={
                                          loadingModelId === String(model.ID) ||
                                          subscribedModelIds.has(
                                            String(model.ID),
                                          )
                                        }
                                        data-tooltip-id={`subscribeTooltip-${model.ID}`}
                                        data-tooltip-content={
                                          subscribedModelIds.has(
                                            String(model.ID),
                                          )
                                            ? "Pending for approval"
                                            : ""
                                        }
                                      >
                                        {subscribedModelIds.has(
                                          String(model.ID),
                                        ) ? (
                                          "Pending"
                                        ) : loadingModelId ===
                                          String(model.ID) ? (
                                          <SvgSpinner />
                                        ) : (
                                          "Subscribe"
                                        )}
                                      </button>
                                        </div>
                                      <ReactTooltip
                                        id={`subscribeTooltip-${model.ID}`}
                                        place="top"
                                        className="custom-tooltip"
                                        content="Pending For Approval"
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    )}

                    {/*  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default MyProfile;
